define(function () {
    const system = require('helpers/system').SystemHelpers;

    return function (html) {
        system.getTemplatesAndResources(html)
            .forEach(function (node) { document.head.appendChild(node) });
    }
});